import { setLoginStateCookie, setToken } from '@/utils/token';
import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';

export default async function urlToken({
  to,
  from,
  next,
  router
}: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
  router: Router;
}) {
  if (to.query.token) {
    const token = to.query.token as string;
    const user = useUserStore();

    // 設置 Token 及登入狀態 (root domain cookie)
    setToken(token);
    setLoginStateCookie(true);
    user.setLoginState(token);

    // 清除網址列中的 token 參數，避免殘留在瀏覽器歷史紀錄
    const { token: _token, ...restQuery } = to.query;
    return { path: to.path, query: restQuery };
  }
  return next();
}
